export default {
  apiKey: 'AIzaSyDtBY5aZ4XxHvmwxlLnhvZKdx2fAMlcbwA',
  authDomain: 'ayk-mall-1534085865701.firebaseapp.com',
  databaseURL: 'https://ayk-mall-1534085865701.firebaseio.com',
  projectId: 'ayk-mall-1534085865701',
  storageBucket: 'ayk-mall-1534085865701.appspot.com',
  messagingSenderId: '981263291613',
};
